import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import {  FarmersRequestModel } from "./farmer-request";



export class FarmerResponseModel extends GlobalResponseObject{
    data?:FarmersRequestModel[]
     
    constructor(status:boolean, intelCode:number, internalMessage:string ,data?:FarmersRequestModel[]){
    super(status,intelCode,internalMessage)
    this.status=status
    this.intlCode=intelCode
    this.internalMessage=internalMessage
    this.data=data
    }

}